import { render } from "./AdminArtistForm.vue?vue&type=template&id=40a2c9d0&scoped=true"
import script from "./AdminArtistForm.vue?vue&type=script&lang=js"
export * from "./AdminArtistForm.vue?vue&type=script&lang=js"

import "./AdminArtistForm.vue?vue&type=style&index=0&id=40a2c9d0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40a2c9d0"]])

export default __exports__